module.exports = __webpack_public_path__ + "img/10788.8c5c3ed0.jpg";